import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import InspectionReportPopup from "./component";

const mapStateToProps = ({
    carDetails: { inspectionReportData, content: { baseUrl } }
}) => ({
    inspectionReportData,
    baseUrl
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InspectionReportPopup);
